/* eslint-disable */
import {
  axios,
  config
} from '../api'
import store from '../store'

let system = {}

system.add = {
  data: {
    ID: 0,
    Name: '',
    Phone: '',
    Password: '',
    DepartName: '',
    RoleCode: ''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/SysUser/Add', _data)
  }
}

system.edit = {
  data: {
    ID: 0,
    Name: '',
    Phone: '',
    Password: '',
    DepartName: '',
    RoleCode: ''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/SysUser/Edit', _data)
  }
}

system.resetPassword = (_DataId) => { // _DataId为id数组
  return axios('post', config.API_URL + '/api/SysUser/ResetPassword',{},{userIdList:_DataId})
}

system.del = (_ID) => {
  return axios('post', config.API_URL + '/api/SysUser/Del', {
    ID: _ID
  })
}

system.getSysUserInfoList = () => {
  return axios('post', config.API_URL + '/api/SysUser/GetSysUserInfoList', {})
}

// 分页获取配置列表
system.getList = {
  data: {
    PageIndex: 1,
    PageSize: 1000,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/SysCfg/GetList', _data)
  }
}

// 修改系统配置
system.editcfg = {
  data: {
    Name: '',
    Value: '',
    Notes: ''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/SysCfg/Edit', _data)
  }
}

export default system


